module.exports = __webpack_public_path__ + "static/media/drawer_phone_inactive.a3d84f99.svg";